<template>
  <div class="wrapper">
    <div class="image-wrapper">
      <img src="../../../../static/images/success-logo.png">
    </div>
    <div class="text-wrapper">
        <div v-if="!isInvestor">
          <h3 class="title">Muchas gracias por realizar tu registro en Cumplo.
            <b>¡Bienvenido!</b>
          </h3>
          <br>
          <h3 class="title">Te asignaremos una cuenta STP (Sistema de Transferencias y Pagos) en un periódo máximo de 24 hrs hábiles.
            Te avisaremos por correo electrónico cuando esté todo listo para que puedas comenzar a fondear tu cuenta virtual. </h3>
        </div>
        <div v-else>
          <h3
            class="title"
          >
            ¡Muchas gracias por mantener tu perfil actualizado!
          </h3>
        </div>
        <button class="button btn--mt" @click="finishedProfile">Finalizar</button>
    </div>
  </div>

</template>

<script>

import CheckmarkOK from '@/components/CheckmarkOK'

export default {
  name: 'StepSuccess',
  components: {
    CheckmarkOK
  },
  computed: {
    isInvestor: function () {
      return this.$store.getters.getIsInvestor
    }
  },
  methods: {
    finishedProfile: async function () {
      await this.$store.dispatch('refreshToken')
      this.$store.dispatch('finishedProfile')
      this.$router.go(-1)
    }
  }
}

</script>

<style lang="scss" scoped>

.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5em;
}

.image-wrapper {
  padding-left: 2em;
  text-align: center;
}

.text-wrapper {
  text-align: center;
  margin-top: 2em;
}
.title {
  font-weight: 400;
  font-size: 1.6rem;
}

.btn--mt {
  margin-top: 1.5em;
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/StepSuccess.vue